import { render, staticRenderFns } from "./ReferralsDashboard.vue?vue&type=template&id=194e7ec8&scoped=true&"
import script from "./ReferralsDashboard.vue?vue&type=script&lang=js&"
export * from "./ReferralsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ReferralsDashboard.vue?vue&type=style&index=0&id=194e7ec8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194e7ec8",
  null
  
)

export default component.exports